// extracted by mini-css-extract-plugin
module.exports = {"figure":"Figure-module--figure--3AU2k"};